module.exports = __webpack_public_path__ + "img/clip_image101.538a3456.png";